<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4">
                    <card>
                        <h5 slot="header" class="card-title"><span @click="goBack()" class="link">Назад</span> -
                            Общая информация</h5>
                        <div class="loader" v-if="waiting"></div>
                        <form>
                            <div class="row">
                                <div class="col-md-10">
                                    <div class="form-group">
                                        <label class="control-label">Проект</label>
                                        <select v-model="task.project_id"
                                                id="status-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="2">My Feed</option>
                                            <option value="9">Muse</option>
                                            <option value="10">Aura</option>
                                            <option value="11">Swipe</option>
                                            <option value="12">Wallpapers</option>
                                            <option value="13">Nola</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Премиум</label>
                                        <select v-model="task.is_premium"
                                                id="status-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="all">Все</option>
                                            <option value="1">Премиум</option>
                                            <option value="0">Не премиум</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Версия</label>
                                        <select v-model="task.version"
                                                id="status-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="all">Все</option>
                                        </select>
                                    </div>
                                    <fg-input type="text"
                                              label="ID рассылки"
                                              v-model="task.push_payload.id"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group" v-if="task.project_id == 9">
                                        <label class="control-label">Тип пуша</label>
                                        <select v-model="task.push_payload.type"
                                                id="status-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="1">Default</option>
                                            <option value="2">Offer</option>
                                            <option value="3">Paywall</option>
                                            <option value="4">Reels Maker</option>
                                            <option value="5">Carousel</option>
                                        </select>
                                    </div>
                                    <fg-input v-if="task.project_id == 9" type="text"
                                              label="ID шаблона"
                                              v-model="task.push_payload.template_id"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Токен (оставить пустым, чтобы отправить всем пользователям)"
                                              v-model="task.token"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="date"
                                              label="Дата отправки (дата пользователя, когда ему придет пуш)"
                                              v-model="client_release_date"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="time" v-if="client_release_date && client_release_date.indexOf('null') < 0"
                                              label="Время отправки (время пользователя, когда ему придет пуш)"
                                              v-model="client_release_time"
                                              placeholder="">
                                    </fg-input>
                                </div>
                            </div>
                            <div class="text-center" v-if="locales[0]">
                                <button type="submit" class="btn btn-success btn-fill float-right btn-save"
                                        :disabled="!locales[0].title && !locales[0].text"
                                        @click.prevent="save">
                                    Сохранить
                                </button>
                            </div>
                            <div class="clearfix"></div>
                        </form>
                    </card>
                </div>
                <div class="col-md-6">
                    <card>
                        <h4 slot="header" class="card-title">Локализация</h4>
                        <div class="loader" v-if="waiting"></div>
                        <form v-if="task">
                            <div class="row">
                                <div class="col-md-10">
                                    <div class="content locale-section" v-for="(itm,index) in locales" :key="index">
                                        <div class="control">
                                            <div class="field">
                                                <p class="locale-block">{{ itm.code }}</p>
                                                <fg-input type="text"
                                                          label="Тайтл"
                                                          v-model="locales[index].title"
                                                          placeholder="">
                                                </fg-input>
                                                <fg-input type="text"
                                                          label="Текст"
                                                          v-model="locales[index].text"
                                                          placeholder="">
                                                </fg-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="clearfix"></div>
                        </form>
                    </card>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import Card from 'src/components/UIComponents/Cards/Card.vue'

    export default {
        name: 'CreateCategory',
        components: {
            Card,
        },
        data() {
            return {
                id: null,
                waiting: false,
                token: localStorage.getItem('token'),
                client_release_date: null,
                client_release_time: '12:00',
                task: {
                    project_id: 9,
                    is_premium: "all",
                    version: "all",
                    token: "",
                    list_key: null,
                    release_date: null,
                    push_payload: {
                        type: "1",
                        id: "",
                        template_id: "",
                    },
                },
                locales: [],
            }
        },
        created: function () {
            this.getLocales();
        },
        methods: {
            goBack: function () {
                window.history.back();
            },
            getLocales: function () {
                let self = this;

                axios.get(
                    `${this.$hostname}/admin/services/locales`,
                    {
                        'headers': {
                            'Authorization': 'Bearer ' + this.token
                        },
                        timeout: 60000,
                    })
                    .then(function (response) {

                        let data = JSON.parse(JSON.stringify(response.data));

                        for (let i = 0; i < data.locales.length; i++) {
                            data.locales[i].code = data.locales[i].locale;
                        }

                        self.locales = data.locales;

                    })
                    .catch(function (error) {

                        const notification = {
                            template: `<span><b>${error.response.data.message}</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-simple-remove',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'danger'
                            })
                    });
            },
            create: function () {
                let self = this;

                //this.waiting = true;

                axios.post(
                    `${self.$hostname}/admin/services/push/tasks/create`,
                    self.task,
                    {
                        'headers': {
                            'Authorization': 'Bearer ' + self.token
                        },
                        timeout: 60000,
                    })
                    .then(function (response) {

                        setTimeout(() => {
                            self.waiting = false;

                            const notification = {
                                template: `<span><b>Задача была успешно создана</b></span>`
                            };

                            self.$notifications.notify(
                                {
                                    component: notification,
                                    icon: 'nc-icon nc-explore-2',
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'info'
                                })

                            self.$router.push('/push-tasks');

                        }, 3000)

                    })
                    .catch(function (error) {

                        self.waiting = false;

                        const notification = {
                            template: `<span><b>${error.response.data.message}</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-simple-remove',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'danger'
                            })
                    });
            },
            save: function () {
                let self = this;

                this.task.locales = JSON.parse(JSON.stringify(this.locales));

                this.task.release_date = this.client_release_date + ' ' + this.client_release_time + ':00';

                this.waiting = true;

                if (this.task.token) {
                    self.create();
                } else {

                    axios.post(
                        `${this.$hostname}/admin/services/push/tasks/audience`,
                        this.task,
                        {
                            'headers': {
                                'Authorization': 'Bearer ' + this.token
                            }
                        })
                        .then(function (response) {

                            if (confirm("Подтвердить отправку уведомления " + response.data + " пользователям")) {

                                self.create();

                            } else {
                                self.waiting = false;
                            }

                        })
                        .catch(function (error) {

                            self.waiting = false;

                            const notification = {
                                template: `<span><b>${error.response.data.message}</b></span>`
                            };

                            self.$notifications.notify(
                                {
                                    component: notification,
                                    icon: 'nc-icon nc-simple-remove',
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'danger'
                                })

                        });
                }

            },
        }
    }

</script>
<style scoped>
    button:disabled,
    button[disabled] {
        cursor: not-allowed;
    }

    .btn-save {
        width: 150px;
    }

    .locale-block {
        text-transform: uppercase;
        font-weight: 700 !important;
        margin-bottom: 0;
        font-style: normal !important;
    }
    .locale-section {
        margin-bottom: 30px;
    }

    .link {
        cursor: pointer;
        text-decoration: underline;
    }

    .card-body p {
        font-weight: 300;
        font-style: italic;
    }

    .card-body form {
        /*margin-top: 15px;*/
    }

    /* Hide the browser's default checkbox */
    .container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    /* On mouse-over, add a grey background color */
    .container:hover input ~ .checkmark {
        opacity: 0.8;
    }

    /* When the checkbox is checked, add a blue background */
    .container input:checked ~ .checkmark {
        background-color: #54abfe;
    }


    /* Show the checkmark when checked */
    .container input:checked ~ .checkmark:after {
        display: block;
    }

    /* Style the checkmark/indicator */
    .container .checkmark:after {
        left: 8px;
        top: 4px;
        width: 5px;
        height: 10px;
        border: solid #fff;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    .device-block span {
        position: absolute;
        top: -30px;
        left: 5px;
    }

    .device-block img {
        width: 40px;
        height: 40px;
        position: absolute;
        right: 18px;
        top: 18px;
    }

    .loader {
        position: fixed;
        top: 0px;
        right: 0px;
        width: 100%;
        height: 100%;
        background-color: #eceaea;
        background-image: url('/static/img/oval.svg');
        background-size: 50px;
        background-repeat: no-repeat;
        background-position: center;
        z-index: 10000000;
        opacity: 0.7;
        filter: alpha(opacity=40);
    }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Push/Create.vue